import { IsArray, IsNotEmpty, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';
import { EditEventSponsorDto } from '@sweatpals/shared';

export class EventSponsorsFormValidator {
	@IsNotEmpty()
	@IsArray()
	@ValidateNested({ each: true })
	@Type(() => EditEventSponsorDto)
	sponsors: EditEventSponsorDto[];
}
